import React from "react"
import Layout from "../components/layout"
import Security from "../components/security"

const SecurityPage = () => <Layout>{data => <Security />}</Layout>

export default SecurityPage
